import React, { memo } from 'react';
import { DollarSign, TrendingUp, Copy, AlertCircle } from 'lucide-react';
import StatCard from '../common/cards/StatCard';
import { formatCurrency } from '../../utils/formatters';

/**
 * Componente que exibe um grid com os principais cards de estatísticas da aplicação.
 * @param {object} props - Propriedades do componente.
 * @param {object} props.stats - Objeto contendo os dados das estatísticas.
 * @param {function} props.onDuplicateClick - Função para ser chamada ao clicar no card de duplicidade.
 * @param {boolean} props.showData - Controla se os valores reais ou placeholders são exibidos.
 * @returns {React.Component} O componente de grid de estatísticas.
 */
const StatsDisplay = memo(({ stats, onDuplicateClick, showData }) => (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        <StatCard 
            icon={<DollarSign className="h-6 w-6 text-green-600 dark:text-green-400"/>}
            title="Custo Mensal Atual"
            value={showData ? formatCurrency(stats.totalCurrentCost) : 'R$ --'}
            description="Baseado nos postes regularizados"
            colorClass="bg-green-100 dark:bg-green-900/50"
        />
        <StatCard 
            icon={<TrendingUp className="h-6 w-6 text-blue-600 dark:text-blue-400"/>}
            title="Custo Mensal Projetado"
            value={showData ? formatCurrency(stats.totalProjectedCost) : 'R$ --'}
            description="Considerando todos os postes"
            colorClass="bg-blue-100 dark:bg-blue-900/50"
        />
        <StatCard 
            icon={<Copy className="h-6 w-6 text-amber-600 dark:text-amber-400"/>}
            title="Postes com Duplicidade"
            value={showData ? stats.duplicatePoleCount : '--'}
            description="Postes com mais de um protocolo"
            colorClass="bg-amber-100 dark:bg-amber-900/50"
            onClick={onDuplicateClick}
        />
        <StatCard 
            icon={<AlertCircle className="h-6 w-6 text-red-600 dark:text-red-400"/>}
            title="Custo Mensal por Duplicidade"
            value={showData ? formatCurrency(stats.duplicateCost) : 'R$ --'}
            description="Custo dos protocolos excedentes"
            colorClass="bg-red-100 dark:bg-red-900/50"
        />
    </div>
));

export default StatsDisplay;
